import React from 'react';
import { Route, createBrowserRouter, createRoutesFromElements, RouterProvider } from 'react-router-dom';

import TemplateListView from './views/TemplateListView/TemplateListView';
import { TemplateListViewV2 } from './views/TemplateListViewV2';
import { QRouteGuard, ToastProvider, useFeatureFlag } from '@qualio/ui-components';
import TemplateDetailView from './views/TemplateDetailView/TemplateDetailView';

const App: React.FC = () => {
  const featureFlags = useFeatureFlag();
  const templateListView = featureFlags['enterprise-accounts'] ? <TemplateListViewV2 /> : <TemplateListView />;

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route
          path="/doc-templates"
          element={<QRouteGuard requiredRoles={['quality']}>{templateListView}</QRouteGuard>}
        />
        <Route
          path="/doc-templates/:templateId"
          element={
            <QRouteGuard requiredRoles={['quality']}>
              <TemplateDetailView />
            </QRouteGuard>
          }
        />
        <Route
          path="/doc-templates/new"
          element={<QRouteGuard requiredRoles={['quality']}>{templateListView}</QRouteGuard>}
        />
      </>,
    ),
  );

  return (
    <ToastProvider enableDelegation={true}>
      <div id="document-templates-container">
        <RouterProvider router={router} useTransitions={false} />
      </div>
    </ToastProvider>
  );
};

export default App;
